module.exports = __webpack_public_path__ + "img/black.29275d16.png";